import { ArticleType } from './article-type.enum';
var ArticleFilterBuilder = /** @class */ (function () {
    function ArticleFilterBuilder() {
        this.articleFilter = {
            categoryIds: [],
            hasAllOfLabelIds: [],
            hasAnyOfLabelIds: [],
            notHasAnyOfLabelIds: [],
            types: [ArticleType.ARTICLE, ArticleType.FEATURE_REQUEST]
        };
    }
    ArticleFilterBuilder.prototype.withCategoryIds = function (categoryIds) {
        this.articleFilter.categoryIds = categoryIds;
        return this;
    };
    ArticleFilterBuilder.prototype.withHasAllOfLabelIds = function (hasAllOfLabelIds) {
        this.articleFilter.hasAllOfLabelIds = hasAllOfLabelIds;
        return this;
    };
    ArticleFilterBuilder.prototype.withHasAnyOfLabelIds = function (hasAnyOfLabelIds) {
        this.articleFilter.hasAnyOfLabelIds = hasAnyOfLabelIds;
        return this;
    };
    ArticleFilterBuilder.prototype.withNotHasAnyOfLabelIds = function (notHasAnyOfLabelIds) {
        this.articleFilter.notHasAnyOfLabelIds = notHasAnyOfLabelIds;
        return this;
    };
    ArticleFilterBuilder.prototype.withTypes = function (types) {
        this.articleFilter.types = types;
        return this;
    };
    ArticleFilterBuilder.prototype.build = function () {
        return this.articleFilter;
    };
    return ArticleFilterBuilder;
}());
export { ArticleFilterBuilder };
//# sourceMappingURL=article-filter.builder.js.map